class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

     if(document.querySelector('.product-recommandation-swiper')){
      const swiper = new Swiper('.product-recommandation-swiper', {
        // Optional parameters
        slidesPerView: 1.3,
        spaceBetween: 12,
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      });


      const recommendedProducts = document.querySelectorAll('.product-recommandation .swiper-slide');
  
      recommendedProducts.forEach(rec_prod => {
        const id = rec_prod.getAttribute('data-variant-id');
        const input = rec_prod.querySelector('.buttons-rt form input[name="id"]');
        const formButton = rec_prod.querySelector('.buttons-rt form button');
        const addToCartButton = rec_prod.querySelector('.product-recommandation-add-to-cart')
        if (input) {
          input.value = id;
        }
  
        addToCartButton.addEventListener('click', () => {
          if (formButton) {
            addToCartButton.classList.add('loading'); // Add 'loading' class
            formButton.click();
  
            setTimeout(() => {
              addToCartButton.classList.remove('loading'); // Remove class after 0.5s
            }, 500);
          }
        });
      });
    }
    
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  

  onCartUpdateUpsell(tagName){
    if (tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          if(document.querySelector('cart-items')){
            document.querySelector('cart-items').innerHTML = sourceQty.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  removeUpsell(items,onCartUpdateUpsell,tagName){
        let formData = {
            updates: {},
        };
        items.forEach(function (item){
            formData["updates"][item.line]=item.quantity;
        })
      fetch('/cart/update.js',
      {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then((response) => response.json())
      .then((response) => {
          if (response.status) {
              // Error function
              console.log("Error")
              return;
          }
          onCartUpdateUpsell(tagName);
      })
      .catch((error) => {
          console.log(error);
      });
    
  }
    
  addUpsell(cartVariants,onCartUpdateUpsell,tagName){
      let formData = {
          items: cartVariants
      };       
      fetch('/cart/add.js',
      {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then(()=>{
          onCartUpdateUpsell(tagName);
      })
      .catch((error) => {
          console.log(error);
      });
  }

  addExtraProductsInCart(items){

    var addUpsell = this.addUpsell;
    var removeUpsell = this.removeUpsell;
    var tagName = this.tagName;
    var onCartUpdateUpsell = this.onCartUpdateUpsell;

    var setAdded = false;
    var giftAdded = false;

    items.forEach(function(value,index){
      if( value.product_id == 8771032187204 ){
        setAdded = true;
      }
      if( value.variant_id == 42927021260954 ){
        giftAdded = true;
      }

      if(items.length == (index+1)){
        if(!giftAdded && setAdded){
          console.log('addUpsell!');
          addUpsell([
            {
                id: 42927021260954,
                quantity: 1,
                price: 0,
                final_price: 0,
                properties: {
                  'nude_set': 'Bonus for nude set'
                }
            }
          ],onCartUpdateUpsell,tagName);
        }
        if(giftAdded && !setAdded){
          console.log('removeupsell!');
          removeUpsell({'line':42927021260954,'quantity': 0},onCartUpdateUpsell,tagName);
        }
      }

    })
  }

  upSellCart(){
    console.log('upSellCart()');
    var addUpsell = this.addUpsell;
    var removeUpsell = this.removeUpsell;
    var tagName = this.tagName;
    var onCartUpdateUpsell = this.onCartUpdateUpsell;
        
    fetch('/cart.js',
    {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    
    })
    .then((response) => {
        return response.json();
    }).then((response)=>{
      console.log('addExtraProductsInCart()');
     
      var addFreeGiftsOnCart=[];
      var removeFreeGiftsOnCart=[];
      
      var free_gifts_array_variant_ids=[];
      var totalFreeGiftsOnCart = 0;

      var setAddedNudePlusOne = false;
      var giftAddedNudePlusOne = false;
      
      var isKeyChainOnCart = false;
      var shouldKeyChainBEOnCart = false;

      var totalAmountInCart = 0;
      var lipButterAddGift = false;
      var giftAddedLipButter = false;
     
      var kismassLipKitAddGift = false;
      var giftaddedkismassLipKit = false;

      
      response.items.forEach(function(value,index){
        if(value.properties && value.properties.upsellingbar_tag){
          free_gifts_array_variant_ids.push(value.variant_id);
          totalFreeGiftsOnCart+=value.final_price;
        }

        if( value.product_id == 8771032187204 ){
          setAddedNudePlusOne = true;
        }
        if( value.variant_id == 42927021260954 ){
          giftAddedNudePlusOne = true;
        }
        
        if(value.variant_id == 55130545389955){
          isKeyChainOnCart = true;
        }
        if( value.properties && ( value.properties.BloomingLip || value.properties.YourDemure || value.properties.BloomGlow)  ){
          shouldKeyChainBEOnCart = true;
        }
        
        if(value.properties && value.properties.EasterShoppingWeek){
          lipButterAddGift = true;
        }
        if(value.properties && value.properties.EasterShoppingWeekGift){
          giftAddedLipButter = true;
        }

        totalAmountInCart+= (value.final_price * value.quantity) ;

        if( value.product_id == 15400135524739 ){
          kismassLipKitAddGift = true;
        }
        if( value.variant_id == 54869457207679 ){
          giftaddedkismassLipKit = true;
        }

        if((index+1)== response.items.length){

          if(totalAmountInCart >= 4900){

             if(!giftaddedkismassLipKit && kismassLipKitAddGift){
                addFreeGiftsOnCart.push({
                    id: 54890223501699,
                    quantity: 1,
                    price: 0,
                    final_price: 0,
                    properties: {
                      'kismass_lip_kit': 'Gift for Kismass Lip Kit'
                    }
                });
              }
              if(giftAddedLipButter && !lipButterAddGift){
                response.items.forEach(function(value,index){
                  if(value.properties && value.properties.EasterShoppingWeekGift && value.variant_id == 54890223501699){
                    removeFreeGiftsOnCart.push({'line':value.key,'quantity': 0});
                  }
                })
              }

             if(!giftAddedLipButter && lipButterAddGift){
                addFreeGiftsOnCart.push({
                    id: 44245809791273,
                    quantity: 1,
                    price: 0,
                    final_price: 0,
                    properties: {
                      'EasterShoppingWeekGift': 'Bonus for Easter Shopping Week'
                    }
                });
              }
              if(giftAddedLipButter && !lipButterAddGift){
                response.items.forEach(function(value,index){
                  if(value.properties && value.properties.EasterShoppingWeekGift && value.variant_id == 44245809791273){
                    removeFreeGiftsOnCart.push({'line':value.key,'quantity': 0});
                  }
                })
              }
          }else{
              response.items.forEach(function(value,index){
                if(value.properties && value.properties.EasterShoppingWeekGift && value.variant_id == 44245809791273){
                  removeFreeGiftsOnCart.push({'line':value.key,'quantity': 0});
                }
              })
          }
          
          if(response.items.length < 4 &&  (isKeyChainOnCart || !shouldKeyChainBEOnCart) ){
              response.items.forEach(function(value,index){
                if(value.variant_id == 55130545389955){
                  removeFreeGiftsOnCart.push({'line':value.key,'quantity': 0});
                }
              })
          }else{
            if(!isKeyChainOnCart && shouldKeyChainBEOnCart){
                addFreeGiftsOnCart.push({
                    id: 55130545389955,
                    quantity: 1,
                    price: 0,
                    final_price: 0,
                    properties: {'KeyChaingift': 'Bonus for Rebel Look set'}
                });
            }
          }
          
          if(window.upsell && window.upsell.length){
            
            if(!giftAddedNudePlusOne && setAddedNudePlusOne){
              addFreeGiftsOnCart.push({
                  id: 42927021260954,
                  quantity: 1,
                  price: 0,
                  final_price: 0,
                  properties: {
                    'nude_set': 'Bonus for nude set'
                  }
              });
            }
            if(giftAddedNudePlusOne && !setAddedNudePlusOne){
              response.items.forEach(function(value,index){
                if(value.properties && value.properties.nude_set && value.variant_id == 42927021260954){
                  removeFreeGiftsOnCart.push({'line':value.key,'quantity': 0});
                }
              })
            }
            

            window.upsell.forEach(function(upSellvalue,upSellindex){
              if(upSellvalue.id && !free_gifts_array_variant_ids.includes(upSellvalue.id)){
                if( ( response.total_price - totalFreeGiftsOnCart ) >= upSellvalue.price ){
                  addFreeGiftsOnCart.push({
                      id: upSellvalue.id,
                      quantity: 1,
                      price: 0,
                      final_price: 0,
                      properties: {
                        'upsellingbar_tag': 'Bonus for cart value'
                      }
                  });
                }
              }
              
              if(upSellvalue.id && free_gifts_array_variant_ids.includes(upSellvalue.id)){
                if( (response.total_price - totalFreeGiftsOnCart) < upSellvalue.price ){
                  response.items.forEach(function(value,index){
                    if(value.properties && value.properties.upsellingbar_tag && value.variant_id == upSellvalue.id){
                      removeFreeGiftsOnCart.push({'line':value.key,'quantity': 0});
                    }
                  })
                }
              }
              if((upSellindex+1) == window.upsell.length){
                
                if(removeFreeGiftsOnCart.length>0){
                  removeUpsell(removeFreeGiftsOnCart,onCartUpdateUpsell,tagName);
                }
                if(addFreeGiftsOnCart.length>0){
                  addUpsell(addFreeGiftsOnCart,onCartUpdateUpsell,tagName);
                }
              }
              
            });
          }else{
            if(!giftAddedNudePlusOne && setAddedNudePlusOne){
              addFreeGiftsOnCart.push({
                  id: 42927021260954,
                  quantity: 1,
                  price: 0,
                  final_price: 0,
                  properties: {
                    'nude_set': 'Bonus for nude set'
                  }
              });
            }
            if(giftAddedNudePlusOne && !setAddedNudePlusOne){
              response.items.forEach(function(value,index){
                if(value.properties && value.properties.nude_set && value.variant_id == 42927021260954){
                  removeFreeGiftsOnCart.push({'line':value.key,'quantity': 0});
                }
              })
            }
            setTimeout(() => {
              if(removeFreeGiftsOnCart.length>0){
                removeUpsell(removeFreeGiftsOnCart,onCartUpdateUpsell,tagName);
              }
              if(addFreeGiftsOnCart.length>0){
                addUpsell(addFreeGiftsOnCart,onCartUpdateUpsell,tagName);
              }
            }, 300);
          }
        }
      })

      
      
      
    })
  }

  onCartUpdate() {
    console.log('update me');
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          this.upSellCart();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          this.upSellCart();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'custom-cart-items',
        section: document.getElementById('custom-cart-items').dataset.id,
        selector: '.main-cart-itemss',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      // {
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '.js-contents',
      // },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.upSellCart();
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
     if(document.querySelector('.product-recommandation-swiper')){
      const swiper = new Swiper('.product-recommandation-swiper', {
        // Optional parameters
        slidesPerView: 1.3,
        spaceBetween: 12,
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      });


      const recommendedProducts = document.querySelectorAll('.product-recommandation .swiper-slide');
  
      recommendedProducts.forEach(rec_prod => {
        const id = rec_prod.getAttribute('data-variant-id');
        const input = rec_prod.querySelector('.buttons-rt form input[name="id"]');
        const formButton = rec_prod.querySelector('.buttons-rt form button');
        const addToCartButton = rec_prod.querySelector('.product-recommandation-add-to-cart')
        if (input) {
          input.value = id;
        }
  
        addToCartButton.addEventListener('click', () => {
          if (formButton) {
            addToCartButton.classList.add('loading'); // Add 'loading' class
            formButton.click();
  
            setTimeout(() => {
              addToCartButton.classList.remove('loading'); // Remove class after 0.5s
            }, 500);
          }
        });
      });
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Update CartDrawer
function updateCartDrawer(open,upsell){
  
    console.log('updateCartDrawer');
  
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      cartItems.upSellCart();
  
  $('cart-drawer').addClass('active');
  $('cart-drawer').removeClass('is-empty');
  fetch('/cart?section_id=cart-drawer').then(function (response) {
      return response.text();
      
  }).then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      const cart = $(doc).find('cart-drawer')[0].innerHTML;
      $(document).find('cart-drawer')[0].innerHTML = cart;
      if(typeof Update_cart_count === 'function'){
        Update_cart_count();
      }
      // if(upsell != true){
      //     // upsellProducts();
      // }
      // // initCartSwatch();
      // $('cart-drawer').removeClass('loading');
      // if(open){
      //     // toggleCustomCartDrawer('open');
      // }
  }).catch(function (err) {
      console.error('Something went wrong.', err);
  });
}
class CartSetRemove extends HTMLElement {
  constructor() {
      super();
      this.addEventListener('click', (event) => {
          event.preventDefault();
          const index = this.closest('cart-set-item').getAttribute('data-item-index');
          this.updateSetProduct(index, 0);
      });
  }
  updateSetProduct(line,quantity) {
      $('#custom-cart-drawer').addClass('loading');
      let line_array = line.split('|')
      let formData = {
          updates: {},
      };
      line_array.forEach(function (item){
          if(item != '') {
              formData["updates"][item] = quantity;
          }
      })
      console.log(formData)
      fetch('/cart/update.js',
          {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
          })
          .then((response) => response.json())
          .then((response) => {
              if (response.status) {
                  // Error function
                  console.log("Error")
                  return;
              }
              const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
              cartItems.upSellCart();
              console.log("Success")
              updateCartDrawer(false,false);
          })
          .catch((error) => {
              console.log(error);
          });
  }
  errorMessage(resp){
      console.log((resp.description));
  }
}
customElements.define('remove-set-item', CartSetRemove);

function updateCartPage(upsell){
  $('#custom-cart-items').addClass('loading');
  fetch(`${routes.cart_url}`).then(function (response) {
      return response.text();
  }).then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      console.log($(doc).find('#custom-cart-items')[0].innerHTML);
      const cart = $(doc).find('#custom-cart-items')[0].innerHTML; 
       $(document).find('#custom-cart-items')[0].innerHTML = cart; 
      if(typeof Update_cart_count === 'function'){
        Update_cart_count();
      }
      
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      cartItems.upSellCart();
    
      initCartSwatch();
      $('#custom-cart-items').removeClass('loading');
  }).catch(function (err) {
      console.error('Something went wrong.', err);
  });
} 
class CartPageSetRemove extends HTMLElement {
  constructor() {
      super();
      this.addEventListener('click', (event) => {
          event.preventDefault();
          const index = this.closest('cart-page-set-item').getAttribute('data-item-index');
          this.updateSetProduct(index, 0);
      });
  }
  updateSetProduct(line,quantity) {
    $('#main-cart-itemss').find('.custom-cart-content').addClass('loading');
      let line_array = line.split('|')
      let formData = {
          updates: {},
      };
      line_array.forEach(function (item){
          if(item != '') {
              formData["updates"][item] = quantity;
          }
      })
      console.log(formData)
      fetch('/cart/update.js',
          {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
          })
          .then((response) => response.json())
          .then((response) => {
              if (response.status) {
                  // Error function
                  console.log("Error")
                  return;
              }
              console.log("Success")
              updateCartPage(false);
          })
          .catch((error) => {
              console.log(error);
          });
  }
  errorMessage(resp){
      console.log((resp.description));
  }
}
customElements.define('remove-cart-set-item', CartPageSetRemove);